import Form, { FormProps } from "@/shared/form/form";
import { TypedDocumentNode, useMutation } from "@apollo/client";
import { ReactNode } from "react";
import { InternalRefetchQueriesInclude } from "@apollo/client/core/types";

export type SmartFormProps<FieldsType> = FormProps<FieldsType> & {
  mutation: TypedDocumentNode<unknown, FieldsType>;
  refetchQueries?: InternalRefetchQueriesInclude;
  afterSubmit?: () => void;
  children?: ReactNode;
};

export function SmartForm<FieldsType>({
  children,
  mutation,
  afterSubmit,
  refetchQueries,
  ...rest
}: SmartFormProps<FieldsType>) {
  const [_save, { loading }] = useMutation(mutation, {
    refetchQueries,
  });

  const save = async (variables: FieldsType) => {
    try {
      await _save({
        variables,
      });
    } catch {
      // Ошибку пользователю уже показал глобальный onError-линк Apollo
      // (shared/graphql/constants/client.ts). Здесь важно не отдать отказ
      // мутации в window.onunhandledrejection (Sentry) и не вызвать afterSubmit
      // после неудачного сохранения.
      return;
    }

    afterSubmit?.();
  };

  return (
    // `disabled` идёт после спреда и складывается с родительским: иначе форма,
    // которой передали свой `disabled`, теряла защиту от повторной отправки.
    <Form
      onFinish={save}
      layout={"vertical"}
      {...rest}
      disabled={loading || rest.disabled}
    >
      {children}
    </Form>
  );
}
